import cx from 'classnames'
import React from 'react'
import style from './index.module.scss'

interface Props {
  appleLogin?: () => void
  className?: string
}

const AppleLoginButton: React.FC<Props> = (props) => {
  return (
    <button
      className={cx(style.appleButton, props.className)}
      onClick={props.appleLogin}
      type="button"
    >
      <svg
        style={{ width: '24px', height: '24px' }}
        height="50"
        viewBox="0 0 50 50"
        width="50"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="m44.527344 34.75c-1.078125 2.394531-1.597656 3.464844-2.984375 5.578125-1.941406 2.953125-4.679688 6.640625-8.0625 6.664063-3.011719.027343-3.789063-1.964844-7.878906-1.929688-4.085938.019531-4.9375 1.96875-7.953125 1.9375-3.386719-.03125-5.976563-3.351562-7.917969-6.300781-5.429688-8.269531-6.003906-17.964844-2.648438-23.121094 2.375-3.65625 6.128907-5.804687 9.65625-5.804687 3.59375 0 5.851563 1.972656 8.820313 1.972656 2.882812 0 4.636719-1.976563 8.792969-1.976563 3.140625 0 6.460937 1.710938 8.835937 4.664063-7.765625 4.257812-6.503906 15.347656 1.339844 18.316406zm-13.332031-26.28125c1.511718-1.941406 2.660156-4.679687 2.242187-7.46875-2.464844.167969-5.347656 1.742188-7.03125 3.78125-1.527344 1.859375-2.792969 4.617188-2.300781 7.285156 2.691406.085938 5.476562-1.519531 7.089844-3.597656z" />
      </svg>

      <div className={style.signinWithApple}>Continue with Apple</div>
    </button>
  )
}

export default AppleLoginButton
